<template>
  <list-input v-bind="localFormItem" v-model="localvalue" @item-changed="itemChanged" />
</template>
<script>
import listinput from 'components/Form/FormListInput.vue';

export default {
  name: 'FormReportListInput',
  components: {
    'list-input': listinput,
  },
  props: {
    v1Config: {},
    v2Config: {},
    value: {},
  },
  data () {
    return {
      localvalue: null,
    };
  },
  methods: {
    itemChanged (item) {
      if (item !== null) {
        if (item.ComponentVersion === undefined){
        } else if (item.ComponentVersion === 1) {
          this.v1Config.value = item.AutoID;
          this.v2Config.value = null;
        } else {
          this.v1Config.value = null;
          this.v2Config.value = item.AutoID;
        }
      } else if (item !== undefined) {
        this.v1Config.value = null;
        this.v2Config.value = null;
      }
    }
  },
  watch: {
    value (newvalue, oldvalue) {
      this.v1Config.listConfig.singleMethod = "GetReportDefinitionItem";
      if (newvalue === null) {
        this.localvalue = this.v2Config.value;
      } else {
        this.localvalue = this.v1Config.value;
      }
    }
  },
  computed: {
    localFormItem () {
      if (this.v1Config !== undefined && this.v1Config !== null && this.v1Config.value !== null) {
        return this.v1Config;
      } else if (this.v2Config !== undefined && this.v2Config !== null && this.v2Config.value !== null) {
        return this.v2Config;
      } else {
        return this.v1Config;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>